import React, { memo, MutableRefObject, useEffect, useState } from 'react';
import classNames from 'classnames';
import cls from './PositionConnection.module.css';
import $ from 'jquery';
import { usePositionConnection } from './usePositionConnection';
import { Connection } from '../../../model/types/positionsConnectionsSliceSchema';
import { stageSelector } from '../../../store/reducers/stageSlice/stageSlice';
import { charterSelector } from '../../../store/reducers/charterSlice/charterSlice';
import { getMinWidth } from '../../../hooks/getMinWidth';
import { useAppDispatch, useAppSelector } from '../../../../../store';
import {
    positionActions,
    positionSelector,
} from '../../../store/reducers/positionSlice/positionSlice';
import { queueFetch } from '../../../helpers/queueFetch';

interface PositionConnection {
    classes?: string;
    connection: Connection;
    diagramRef: MutableRefObject<null>;
}

export const PositionConnection = memo(
    ({ classes, connection, diagramRef }: PositionConnection) => {
        const {} = usePositionConnection();
        const { activeTab, nestingTabs } = useAppSelector((state) => state.gantReducer);
        const [leftForFact, setLeftForFact] = useState(0);

        const { from, to, type } = connection;
        const [coordinates, setCoordinates] = useState({
            height: 0,
            positionWidth: 0,
            width: 0,
            positionToWidth: 0,
            positionFromWidth: 0,
            positionFromTop: 0,
            left: 0,
        });

        console.log('coordinates', coordinates);

        useEffect(() => {
            console.log('render');
            // const positionFrom = $(document).find(`[data-position-guid=${from}]`);
            // const positionTo = $(document).find(`[data-position-guid=${to}]`);
            //
            // const offsetPositionTo = positionTo.offset();
            // const offsetPositionFrom = positionFrom.offset();
            const positionFromElement = diagramRef.current.querySelector(
                `[data-position-guid="${from}"]`
            );
            const positionToElement = diagramRef.current.querySelector(
                `[data-position-guid="${to}"]`
            );
            if (positionFromElement && positionToElement) {
                // Получаем координаты элемента относительно окна
                const positionFromRect = positionFromElement.getBoundingClientRect();
                const positionToRect = positionToElement.getBoundingClientRect();
                // Получаем координаты контейнера относительно окна
                const containerRect = diagramRef.current.getBoundingClientRect();

                // Вычисляем координаты элемента относительно контейнера:
                const relativeX = positionFromRect.left - containerRect.left;
                const relativeY = positionFromRect.top - containerRect.top;

                // Ширина элемента:
                const width = positionFromRect.width;

                const height = positionToRect.top - positionFromRect.top;
                setCoordinates({
                    ...coordinates,
                    height,
                    left: Math.abs(relativeX),
                    width,
                    positionWidth: width,
                });
            }

            // if (offsetPositionTo && offsetPositionFrom) {
            //     const positionFromLeft = positionFrom.css('left');
            //     const leftValueNumeric = parseInt(positionFromLeft, 10);
            //     setLeftForFact(leftValueNumeric);
            //
            //     const positionToWidth = positionTo.width();
            //
            //     if (!!positionTo) {
            //         setCoordinates({
            //             height: offsetPositionTo.top - offsetPositionFrom.top,
            //             width: offsetPositionTo.left - offsetPositionFrom.left,
            //             positionWidth: positionToWidth,
            //         });
            //     }
            // }
        }, [nestingTabs]);

        // const allStage = useAppSelector(stageSelector.selectAll);
        // const allCharters = useAppSelector(charterSelector.selectAll);
        // const minWidth = getMinWidth(activeTab);

        const resultLeft = 10;
        // const resultLeft = left < minWidth ? minWidth : left;

        const [isHover, setIsHover] = useState(false);
        const dispatch = useAppDispatch();
        const [isShow, setIsShow] = useState(false);
        const allPosition = useAppSelector(positionSelector.selectEntities);

        const positionTo = allPosition[to];

        let scaleError = 0;
        let positionX = 0;

        if (activeTab === 'week') {
            if (positionTo.planned.days_count == '1') {
                scaleError = 4;
            }
        }

        if (activeTab === 'month') {
            if (positionTo.planned.days_count == '1') {
                scaleError = 6;
            }
            if (positionTo.planned.days_count == '2') {
                scaleError = 4;
            }
        }

        const deleteConnection = () => {
            // const positionFrom = allPosition[connection.from];
            // const positionTo = allPosition[connection.to];
            //
            // const parentCharter = allCharters.find((charter) =>
            //     charter.children.includes(positionTo.guid)
            // );
            // const parentStage = allStage.find((stage) => {
            //     const childGuid = parentCharter ? parentCharter.guid : positionTo.guid;
            //     return stage.positions.includes(childGuid);
            // });
            //
            // const queueConnections = [
            //     {
            //         data: {
            //             data: {
            //                 connection: [
            //                     {
            //                         positionFromGuid: positionFrom.guid,
            //                         positionToGuid: positionTo.guid,
            //                     },
            //                 ],
            //             },
            //             type: 'remove_connections',
            //             action: 'remove_connections',
            //         },
            //         subEntityType: 'step',
            //         subEntityId: parentStage.id,
            //         t: Date.now(),
            //     },
            // ];
            //
            // queueFetch(queueConnections);
            //
            // const connectionsFrom = positionFrom.connections.filter((connectionFrom) => {
            //     return connectionFrom.to !== connection.to;
            // });
            //
            // const connectionsTo = positionTo.connections.filter(
            //     (connectionTo) => connectionTo.from !== connection.from
            // );
            //
            // dispatch(
            //     positionActions.updateMany([
            //         {
            //             id: positionFrom.guid,
            //             changes: { ...positionFrom, connections: connectionsFrom },
            //         },
            //         {
            //             id: positionTo.guid,
            //             changes: { ...positionTo, connections: connectionsTo },
            //         },
            //     ])
            // );
            // setIsShow(false);
        };

        const onMouseEnter = () => {
            //@ts-ignore
            if (isPlanFact) return;

            setIsHover(true);
        };
        const onMouseLeave = () => {
            //@ts-ignore
            if (isPlanFact) return;
            setIsHover(false);
        };

        // console.log('type === 0 && coordinates.height > 0', type === 0 && coordinates.height > 0);
        return (
            <>
                {type === 0 && coordinates.height > 0 && (
                    <div
                        className={classNames(cls.wrapper, { [cls.activeWrapper]: isHover })}
                        style={{ left: resultLeft }}
                    >
                        {isHover && (
                            <div
                                className={cls.delete}
                                style={{
                                    left: coordinates.left + 2 - scaleError,
                                    top: isPlanFact ? 8 : '',
                                }}
                                onClick={() => setIsShow(true)}
                                onMouseEnter={onMouseEnter}
                                onMouseLeave={onMouseLeave}
                            >
                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g clipPath="url(#clip0_1561_40383)">
                                        <rect width="16" height="16" rx="8" fill="white" />
                                        <path
                                            d="M5.12 12L8 9.12L10.88 12L12 10.88L9.12 8L12 5.12L10.88 4L8 6.88L5.12 4L4 5.12L6.88 8L4 10.88L5.12 12ZM8 16C6.89333 16 5.85333 15.79 4.88 15.37C3.90667 14.95 3.06 14.38 2.34 13.66C1.62 12.94 1.05 12.0933 0.63 11.12C0.21 10.1467 0 9.10667 0 8C0 6.89333 0.21 5.85333 0.63 4.88C1.05 3.90667 1.62 3.06 2.34 2.34C3.06 1.62 3.90667 1.05 4.88 0.63C5.85333 0.21 6.89333 0 8 0C9.10667 0 10.1467 0.21 11.12 0.63C12.0933 1.05 12.94 1.62 13.66 2.34C14.38 3.06 14.95 3.90667 15.37 4.88C15.79 5.85333 16 6.89333 16 8C16 9.10667 15.79 10.1467 15.37 11.12C14.95 12.0933 14.38 12.94 13.66 13.66C12.94 14.38 12.0933 14.95 11.12 15.37C10.1467 15.79 9.10667 16 8 16ZM8 14.4C9.78667 14.4 11.3 13.78 12.54 12.54C13.78 11.3 14.4 9.78667 14.4 8C14.4 6.21333 13.78 4.7 12.54 3.46C11.3 2.22 9.78667 1.6 8 1.6C6.21333 1.6 4.7 2.22 3.46 3.46C2.22 4.7 1.6 6.21333 1.6 8C1.6 9.78667 2.22 11.3 3.46 12.54C4.7 13.78 6.21333 14.4 8 14.4Z"
                                            fill="#1094F7"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_1561_40383">
                                            <rect width="16" height="16" rx="8" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                        )}

                        <div
                            style={{
                                width:
                                    coordinates.width - resultLeft + 10 + -positionX - scaleError,
                                left: coordinates.left,
                                height: 15,
                                top: isPlanFact ? 0 : '',
                            }}
                            className={classNames(cls.lineArrowWrapper)}
                            onMouseEnter={onMouseEnter}
                            onMouseLeave={onMouseLeave}
                        >
                            <div
                                style={{
                                    height: 2,
                                    width: coordinates.width - resultLeft + 10 + -positionX,
                                    top: isPlanFact ? 0 : '',
                                }}
                                className={classNames(cls.lineArrow, { [cls.hovered]: isHover })}
                            ></div>
                        </div>
                        <div
                            className={classNames(cls.lineArrowWrapper)}
                            style={{
                                height: coordinates.height - 10,
                                width: 15,
                                left: coordinates.width - resultLeft + 2 - scaleError,
                                top: isPlanFact ? 7 : -1,
                            }}
                            onMouseEnter={onMouseEnter}
                            onMouseLeave={onMouseLeave}
                        >
                            <div
                                style={{ height: coordinates.height - 10, width: 2 }}
                                className={classNames(cls.lineArrow, { [cls.hovered]: isHover })}
                            >
                                <svg
                                    width="12"
                                    height="8"
                                    viewBox="0 0 12 8"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    className={cls.arrow}
                                >
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M0.292847 1.70718L1.70706 0.292969L5.99995 4.58586L10.2928 0.292969L11.7071 1.70718L5.99995 7.41429L0.292847 1.70718Z"
                                        fill="#1094F7"
                                    />
                                </svg>
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    }
);
